module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/readable-stream/transform.js
 ** module id = 52
 ** module chunks = 0
 **/